// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__3xE4K","title":"card_title__22JEd","inActive":"card_inActive__3f3yx"};